// NOTE ensure the namespace and any dependencies are set up appropriately, for both server and client
let _;
let moment;
let RivalIQ;
if (typeof window === 'undefined') {

    _ = require('lodash');
    moment = require('../../../lib/riq-moment.js');
    RivalIQ = {
        enums: require('../../enums/metrics.js'),
        data: {
            CompareData: require('../data/compareData.js'),
            LinkedInJobFunctionMap: require('../data/linkedInJobFunctions.js')
        },
        utils: {}
    };

    RivalIQ.utils.companyDisplay = module.exports;

} else {
    _ = window._;
    moment = window.moment;
    RivalIQ = window.RivalIQ;
    RivalIQ.module('utils', function (utils) {
        'use strict';

        utils.companyDisplay = {};
    });
}

(function (companyDisplay, CompareData) {
    'use strict';

    function parseUrl(url) {

        let components = null;
        const names = [
            'url',
            'protocol',
            'slash',
            'host',
            'port',
            'path',
            'query',
            'hash'
        ];

        // parse the url; thanks Douglas Crockford for the regex!
        const regex = /^(?:([A-Za-z]+):)?(\/{0,3})([0-9.\-A-Za-z]+)(?::(\d+))?(?:\/([^?#]*))?(?:\?([^#]*))?(?:#(.*))?$/;
        const result = regex.exec(url);

        if (result) {
            // map the regex capture groups to meaningful names
            components = {};
            for (let i = 0; i < names.length; i++) {
                components[names[i]] = result[i];
            }
        }
        return components;
    }

    function averageImpressionByLocation(primaryRecord, metric) {
        const result = {};
        const days = _.size(primaryRecord.dailyValues);
        _.each(primaryRecord.dailyValues, function (day) {
            const cities = _.get(day, [metric, 'submetrics'], {});
            _.each(cities, function (value, location) {
                result[location] = (result[location] || 0) + value.value;
            });
        });

        const cities = _.keys(result);
        _.each(cities, function (location) {
            result[location] = result[location] / days;
        });

        return result;
    }

    companyDisplay.getIcon = function (companyRecord) {
        let iconUrl = null;
        let tw;
        let f;
        let i;
        const cd = companyDisplay;
        if (companyRecord.periodSummary) {
            if (cd.hasTwitter(companyRecord) && (tw = cd.getPrimaryTwitterRecord(companyRecord)) &&
                tw.presence.icon_url && !tw.presence.icon_url.match('default_profile')) {

                iconUrl = tw.presence.icon_url.replace(RivalIQ.enums.sourceDetails[RivalIQ.enums.sources.TWITTER].lowResImgSuffix, '');

            } else if (cd.hasFacebook(companyRecord) && (f = cd.getPrimaryFacebookRecord(companyRecord)) && f.presence.icon_url) {
                iconUrl = f.presence.icon_url;

            } else if (cd.hasInstagram(companyRecord) && (i = cd.getPrimaryInstagramRecord(companyRecord)) && i.presence.icon_url) {
                iconUrl = i.presence.icon_url;

            } else if (cd.hasTiktok(companyRecord) && (i = cd.getPrimaryTiktokRecord(companyRecord)) && i.presence.icon_url) {
                iconUrl = i.presence.icon_url;

            }
        }
        return iconUrl;
    };

    companyDisplay.getNameAbbreviation = function (name) {
        let abbr = '?';
        if (name) {
            const cleanedName = name.replace(/^www\./i, '');
            abbr = cleanedName.slice(0, 1).toUpperCase();
        }
        return abbr;
    };

    companyDisplay.getAbbreviation = function (companyRecord) {
        const name = _.get(companyRecord, ['name']);
        return companyDisplay.getNameAbbreviation(name);
    };

    companyDisplay.getDescription = function (companyRecord) {
        const cd = companyDisplay;
        let tw;
        let f;
        let w;
        let i;
        const notFoundMsg = 'We found the web site you added, but we were unable to extract any overview information.';
        let desc = notFoundMsg;
        if (companyRecord.periodSummary) {
            if (cd.hasTwitter(companyRecord) && (tw = cd.getPrimaryTwitterRecord(companyRecord)) && tw.presence.overview) {
                desc = tw.presence.overview;

            } else if (cd.hasFacebook(companyRecord) && (f = cd.getPrimaryFacebookRecord(companyRecord)) && f.presence.overview) {
                desc = f.presence.overview;

            } else if (cd.hasInstagram(companyRecord) && (i = cd.getPrimaryInstagramRecord(companyRecord)) && i.presence.overview) {
                desc = i.presence.overview;

            } else if (cd.hasYouTube(companyRecord) && (i = cd.getPrimaryYouTubeRecord(companyRecord)) && i.presence.overview) {
                desc = i.presence.overview;

            } else if (cd.hasTiktok(companyRecord) && (i = cd.getPrimaryTiktokRecord(companyRecord)) && i.presence.signature) {
                desc = i.presence.signature;

            } else if (cd.hasDomain(companyRecord) && (w = cd.getPrimaryDomainRecord(companyRecord))) {

                if (w.presence.meta_description) {
                    desc = w.presence.meta_description;
                } else if (w.presence.title) {
                    desc = w.presence.title;
                } else {
                    desc = notFoundMsg;
                }
            }
        }
        return desc;
    };

    companyDisplay.getPrimaryTrendPresenceValue = function (companyRecord, trend, value) {
        return _.get(companyRecord, [
            'periodSummary',
            trend,
            0,
            'presence',
            value
        ]);
    };

    companyDisplay.hasTwitter = function (companyRecord) {
        return companyDisplay.hasSource(RivalIQ.enums.sources.TWITTER, companyRecord);
    };

    companyDisplay.getPrimaryTwitterRecord = function (companyRecord) {
        return companyDisplay.getSourcePrimaryRecord(RivalIQ.enums.sources.TWITTER, companyRecord);
    };

    companyDisplay.getTwitterOverview = function (companyRecord) {
        return companyDisplay.getPrimaryTrendPresenceValue(companyRecord, 'twitterTrends', 'overview');
    };

    companyDisplay.getTwitterIcon = function (companyRecord) {
        return companyDisplay.getPrimaryTrendPresenceValue(companyRecord, 'twitterTrends', 'icon_url');
    };

    companyDisplay.getTwitterLink = function (companyRecord) {
        return `https://twitter.com/${companyDisplay.getPrimaryTrendPresenceValue(companyRecord, 'twitterTrends', 'handle')}`;
    };

    companyDisplay.getTwitterDecoratedHandle = function (companyRecord) {
        return `@${companyDisplay.getPrimaryTrendPresenceValue(companyRecord, 'twitterTrends', 'handle')}`;
    };

    companyDisplay.hasFacebook = function (companyRecord) {
        return (companyRecord.periodSummary.facebookTrends && companyRecord.periodSummary.facebookTrends[0] && companyRecord.periodSummary.facebookTrends[0].presence !== null);
    };

    companyDisplay.getPrimaryFacebookRecord = function (companyRecord) {
        return companyDisplay.getSourcePrimaryRecord(RivalIQ.enums.sources.FACEBOOK, companyRecord);
    };

    companyDisplay.getFacebookIcon = function (companyRecord) {
        return companyDisplay.getPrimaryTrendPresenceValue(companyRecord, 'facebookTrends', 'icon_url');
    };

    companyDisplay.getFacebookLink = function (companyRecord) {
        // use handle if available, native_id if not
        const bestFacebookId = companyDisplay.getPrimaryTrendPresenceValue(companyRecord, 'facebookTrends', 'handle') || companyDisplay.getPrimaryTrendPresenceValue(companyRecord, 'facebookTrends', 'native_id');
        return `https://facebook.com/${bestFacebookId}`;
    };

    companyDisplay.getFacebookDecoratedHandle = function (companyRecord) {
        // some facebook accounts don't have handle but only native id.
        // https://github.com/RivalIQ/rivaliq-server/pull/28003#pullrequestreview-568483471
        const handle = companyDisplay.getPrimaryTrendPresenceValue(companyRecord, 'facebookTrends', 'handle');
        if (handle) {
            return `@${handle}`;
        } else {
            return companyDisplay.getPrimaryTrendPresenceValue(companyRecord, 'facebookTrends', 'native_id');
        }
    };

    function addUnspecifiedCount(total, topNTotal, breakdown) {

        // NOTE the sum of the submetrics may not equal the actual total, in
        // which case we add in our own 'unspecified' count

        const unspecifiedCount = total - topNTotal;

        if (unspecifiedCount > 0) {
            breakdown.Unspecified = unspecifiedCount;
        }
    }

    // TODO replace with metric model
    companyDisplay.getFacebookDemographics = function (companyRecord, locationType, demographicType) {

        const primaryRecord = companyDisplay.getSourcePrimaryRecord(RivalIQ.enums.sources.FACEBOOK_INSIGHTS, companyRecord);

        function oldPageFansSubmetricsIncludingOther(locationType) {
            let submetrics = _.get(primaryRecord, `period2.page_fans_${locationType}.submetrics`, {});
            submetrics = _.mapValues(submetrics, _.property('value'));

            const total = _.get(primaryRecord, 'period2.page_fans');
            const topNTotal = _.get(primaryRecord, `period2.page_fans_${locationType}.value`);

            addUnspecifiedCount(total, topNTotal, submetrics);

            return submetrics;
        }

        function pageFansSubmetricsIncludingOther(demographicType) {
            let submetrics;
            let total;
            let topNTotal;

            if (demographicType === 'fans-by-country') {
                submetrics = _.get(primaryRecord, 'period2.page_fans_country.submetrics');
                submetrics = _.mapValues(submetrics, _.property('value'));
                total = _.get(primaryRecord, 'period2.page_fans');
                topNTotal = _.get(primaryRecord, 'period2.page_fans_country.value');
            } else if (demographicType === 'fans-by-city') {
                submetrics = _.get(primaryRecord, 'period2.page_fans_city.submetrics');
                submetrics = _.mapValues(submetrics, _.property('value'));
                total = _.get(primaryRecord, 'period2.page_fans');
                topNTotal = _.get(primaryRecord, 'period2.page_fans_city.value');
            } else {
                // empty
            }
            addUnspecifiedCount(total, topNTotal, submetrics);

            return submetrics;
        }

        let numWomen;
        let numMen;
        let numUnspecified;
        let numDates;

        if (primaryRecord && demographicType) {
            switch (demographicType) {
                case 'fans-by-country':
                    return pageFansSubmetricsIncludingOther(demographicType);
                case 'fans-by-city':
                    return pageFansSubmetricsIncludingOther(demographicType);
                case 'reach-by-country':
                    return averageImpressionByLocation(primaryRecord, 'page_impressions_by_country_unique');
                case 'reach-by-city':
                    return averageImpressionByLocation(primaryRecord, 'page_impressions_by_city_unique');
                case 'fans-by-age-gender':
                    numWomen = _.get(primaryRecord, 'period2.page_fans_gender_age.submetrics.F.value');
                    numMen = _.get(primaryRecord, 'period2.page_fans_gender_age.submetrics.M.value');
                    numUnspecified = _.get(primaryRecord, 'period2.page_fans_gender_age.submetrics.U.value');

                    if (_.isUndefined(numWomen) || _.isUndefined(numMen) || _.isUndefined(numUnspecified)) {
                        return {};
                    } else {
                        return {
                            Women: numWomen,
                            Men: numMen,
                            Unspecified: numUnspecified
                        };
                    }

                case 'reach-by-age-gender':
                // "dataWarning" is cause of an insufficient aount of data.
                // https://github.com/RivalIQ/rivaliq-server/issues/25195
                    if (_.isUndefined(primaryRecord.dataWarning)) {
                        numDates = _.get(companyRecord, ['periodSummary', 'dates', 'mainPeriodDuration']);
                    } else {
                    // When we have an insufficient amount of data, "count" is the total number of days we do have for in the period.
                        numDates = _.get(primaryRecord, 'dataWarning.page_impressions_by_age_gender_unique.count');
                    }
                    numWomen = _.get(primaryRecord, 'period2.page_impressions_by_age_gender_unique.submetrics.F.value');
                    numMen = _.get(primaryRecord, 'period2.page_impressions_by_age_gender_unique.submetrics.M.value');
                    numUnspecified = _.get(primaryRecord, 'period2.page_impressions_by_age_gender_unique.submetrics.U.value');

                    if (_.isUndefined(numWomen) || _.isUndefined(numMen) || _.isUndefined(numUnspecified) || _.isUndefined(numDates) || _.isNull(numDates) || numDates === 0) {
                        return {};
                    } else {
                        return {
                            Women: numWomen / numDates,
                            Men: numMen / numDates,
                            Unspecified: numUnspecified / numDates
                        };
                    }
                default:
                    throw new Error(`unknown demographic type ${demographicType}`);
            }
        }

        if (primaryRecord && locationType) {
            switch (locationType) {
                case 'impressions-by-city':
                    return averageImpressionByLocation(primaryRecord, 'page_impressions_by_city_unique');
                case 'impressions-by-country':
                    return averageImpressionByLocation(primaryRecord, 'page_impressions_by_country_unique');
                case 'city':
                case 'country':
                    return oldPageFansSubmetricsIncludingOther(locationType);
                default:
                    throw new Error(`unknown location type ${locationType}`);
            }
        }

        return {};
    };

    companyDisplay.getInstaDemographics = function (companyRecord, demographicType) {
        const cd = companyDisplay;

        const primaryRecord = cd.getSourcePrimaryRecord(RivalIQ.enums.sources.INSTAGRAM_INSIGHTS, companyRecord);

        // reverse iterate to pass back the most recent data we have
        const demographics = {};
        _.findLast(primaryRecord.dailyValues, function (day) {
            let relevantDemographic = _.get(day, [`audience_${demographicType}`, 'submetrics']);
            if (relevantDemographic) {
                if (demographicType === 'gender_age') {
                    // use better names for the categories
                    if (relevantDemographic.F) {
                        relevantDemographic.Women = relevantDemographic.F;
                        relevantDemographic = _.omit(relevantDemographic, 'F');
                    }
                    if (relevantDemographic.M) {
                        relevantDemographic.Men = relevantDemographic.M;
                        relevantDemographic = _.omit(relevantDemographic, 'M');
                    }
                    if (relevantDemographic.U) {
                        relevantDemographic.Unspecified = relevantDemographic.U;
                        relevantDemographic = _.omit(relevantDemographic, 'U');
                    }
                }
                _.forEach(relevantDemographic, function (value, key) {
                    demographics[key] = value.value;
                });
                return true;
            }
        });

        if (!_.isEmpty(demographics) && _.includes(['country', 'city'], demographicType)) {

            // NOTE the sum of the submetrics may not equal the actual total, in
            // which case we add in our own 'unspecified' count
            const total = _.get(primaryRecord, 'period2.followers_count');
            const topNTotal = _.get(primaryRecord, `period2.audience_${demographicType}.value`);

            addUnspecifiedCount(total, topNTotal, demographics);
        }

        return _.isEmpty(demographics) ? null : demographics;
    };

    companyDisplay.getLinkedInDemographics = function (companyRecord, demographicType) {
        const cd = companyDisplay;

        const primaryRecord = cd.getPrimaryLinkedInRecord(companyRecord);

        if (demographicType === 'city') {
            return _.get(primaryRecord, ['presence', 'latestStats', 'followers_by_region']);
        } else if (demographicType === 'industry') {
            return _.get(primaryRecord, ['presence', 'latestStats', 'followers_by_industry']);
        } else if (demographicType === 'job-function') {
            return _.get(primaryRecord, ['presence', 'latestStats', 'followers_by_job_function']);
        } else {
            return _.get(primaryRecord, ['presence', 'latestStats', 'followers_by_country']);
        }
    };

    /**
     * Determines whether a specified trend at an index on a company record is suitable for display.
     * @param trend
     * @param index
     * @param companyRecord
     * @returns {boolean}
     */
    companyDisplay.hasTrendRecord = function (trend, index, companyRecord) {
        return _.exists(_.get(companyRecord, ['periodSummary', trend, index, 'presence']));
    };

    companyDisplay.hasDomain = function (companyRecord) {
        return companyDisplay.hasSource(RivalIQ.enums.sources.WEB, companyRecord);
    };

    companyDisplay.getPrimaryDomainRecord = function (companyRecord) {
        return companyDisplay.getSourcePrimaryRecord(RivalIQ.enums.sources.WEB, companyRecord);
    };

    companyDisplay.getDomainLink = function (companyRecord) {
        const domain = companyDisplay.getPrimaryDomainRecord(companyRecord);

        return (domain ? domain.presence.source : null);
    };

    companyDisplay.getCleanSource = function (companyRecord) {

        let source = null;
        const domain = companyDisplay.getPrimaryDomainRecord(companyRecord);
        const presenceSource = _.get(domain, 'presence.source');

        if (presenceSource) {

            const location = parseUrl(presenceSource);
            source = location.host;
            if (!location.path.match(/^\s*$/)) {
                source += `/${location.path}`;
            }
        }

        return source;
    };

    companyDisplay.getPrimaryLinkedInRecord = function (companyRecord) {
        return companyDisplay.getSourcePrimaryRecord(RivalIQ.enums.sources.LINKEDIN, companyRecord);
    };

    companyDisplay.hasYouTube = function (companyRecord) {
        return companyDisplay.hasSource(RivalIQ.enums.sources.YOUTUBE, companyRecord);
    };

    companyDisplay.getPrimaryYouTubeRecord = function (companyRecord) {
        return companyDisplay.getSourcePrimaryRecord(RivalIQ.enums.sources.YOUTUBE, companyRecord);
    };

    companyDisplay.getYouTubeLink = function (companyRecord) {
        return `https://www.youtube.com/channel/${companyDisplay.getPrimaryTrendPresenceValue(companyRecord, 'youTubeTrends', 'native_id')}`;
    };

    companyDisplay.hasInstagram = function (companyRecord) {
        return companyDisplay.hasSource(RivalIQ.enums.sources.INSTAGRAM, companyRecord);
    };

    companyDisplay.getPrimaryInstagramRecord = function (companyRecord) {
        return companyDisplay.getSourcePrimaryRecord(RivalIQ.enums.sources.INSTAGRAM, companyRecord);
    };

    companyDisplay.getInstagramLink = function (companyRecord) {
        return `https://instagram.com/${companyDisplay.getPrimaryTrendPresenceValue(companyRecord, 'instagramTrends', 'handle')}`;
    };

    companyDisplay.getInstagramDecoratedHandle = function (companyRecord) {
        return `@${companyDisplay.getPrimaryTrendPresenceValue(companyRecord, 'instagramTrends', 'handle')}`;
    };

    companyDisplay.hasTiktok = function (companyRecord) {
        return companyDisplay.hasSource(RivalIQ.enums.sources.TIKTOK, companyRecord);
    };

    companyDisplay.getPrimaryTiktokRecord = function (companyRecord) {
        return companyDisplay.getSourcePrimaryRecord(RivalIQ.enums.sources.TIKTOK, companyRecord);
    };

    companyDisplay.getTiktokLink = function (companyRecord) {
        return `https://www.tiktok.com/@${companyDisplay.getPrimaryTrendPresenceValue(companyRecord, 'tiktokTrends', 'handle')}`;
    };

    companyDisplay.getTiktokDecoratedHandle = function (companyRecord) {
        return `@${companyDisplay.getPrimaryTrendPresenceValue(companyRecord, 'tiktokTrends', 'handle')}`;
    };

    companyDisplay.getSourcePrimaryRecord = function (source, companyRecord) {

        const sourceDetails = RivalIQ.enums.sourceDetails[source];
        return _.get(companyRecord, ['periodSummary', sourceDetails.trendKey, 0], null);
    };

    // NOTE this is meant to replicate `CompareData#hasChannelBySource`
    companyDisplay.hasChannel = function (channel, companyRecord) {
        const source = RivalIQ.data.channels.get(channel).get('source');
        const sourceDetails = RivalIQ.enums.sourceDetails[source];
        if (sourceDetails && sourceDetails.subSources) {
            return _.some(sourceDetails.subSources, function (subSource) {
                return companyDisplay.hasSource(subSource, companyRecord);
            });
        }
        return companyDisplay.hasSource(source, companyRecord);
    };

    companyDisplay.hasSource = function (source, companyRecord) {
        return Boolean(_.get(companyDisplay.getSourcePrimaryRecord(source, companyRecord), 'presence'));
    };

    companyDisplay.getSourceLink = function (source, companyRecord) {

        const map = {};
        map[RivalIQ.enums.sources.TWITTER] = companyDisplay.getTwitterLink;
        map[RivalIQ.enums.sources.FACEBOOK] = companyDisplay.getFacebookLink;
        map[RivalIQ.enums.sources.YOUTUBE] = companyDisplay.getYouTubeLink;
        map[RivalIQ.enums.sources.INSTAGRAM] = companyDisplay.getInstagramLink;
        map[RivalIQ.enums.sources.TIKTOK] = companyDisplay.getTiktokLink;
        const fn = _.get(map, source, _.partial(_.identity, null));
        return ((companyDisplay.hasSource(source, companyRecord)) ? fn(companyRecord) : null);
    };

    companyDisplay.hasAnySocialChannel = function (companyRecord) {

        return _.some(RivalIQ.enums.sourceDetails, function (sourceDetails, source) {

            return (sourceDetails.group === 'social' && companyDisplay.hasSource(source, companyRecord));
        });
    };

    /**
     * Retrieves a company icon from a metric source.
     */
    companyDisplay.getIconFromMetricSource = function (source, companyRecord, presenceId) {

        let record;

        if (!_.includes(_.values(RivalIQ.enums.sources), source)) {

            return companyDisplay.getIcon(companyRecord);
        }

        const sourceDetails = RivalIQ.enums.sourceDetails[source];

        if (sourceDetails.group !== 'social' && source !== RivalIQ.enums.sources.LINKEDIN) {

            return companyDisplay.getIcon(companyRecord);
        }

        if (presenceId) {

            const trends = _.get(companyRecord, ['periodSummary', _.get(sourceDetails, 'trendKey')], []);
            record = _.find(trends, {
                presence: {
                    native_id: presenceId
                }
            });
        } else {

            record = companyDisplay.getSourcePrimaryRecord(source, companyRecord);
        }

        return _.get(record, 'presence.icon_url');
    };

    /**
     * Retrieves a channel presence icon from a metric.
     */
    companyDisplay.getIconFromMetric = function (metric, companyRecord, presenceId) {
        const compareData = new CompareData();
        const source = compareData.getMetricSource(metric);
        return companyDisplay.getIconFromMetricSource(source, companyRecord, presenceId);
    };

    /**
     * Retrieves a channel presence icon by channel name.
     */
    companyDisplay.getChannelPresenceIcon = function (channel, companyRecord, presenceId) {
        const source = RivalIQ.enums.sources[channel.toUpperCase()];
        return companyDisplay.getIconFromMetricSource(source, companyRecord, presenceId);
    };

    companyDisplay.getCompanyAge = function (companyRecord, measurement, useFloat) {

        const now = moment.utc();
        const then = moment.utc(companyRecord.created_at);

        if (!measurement) {

            measurement = 'days';
        }

        return now.diff(then, measurement, useFloat);
    };

})(RivalIQ.utils.companyDisplay, RivalIQ.data.CompareData);
